// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "592a4f7c6d84c912f2dd41a2331b272c" + ".js";
};